import { render, staticRenderFns } from "./outlinetable.vue?vue&type=template&id=64273efa&scoped=true"
import script from "./outlinetable.vue?vue&type=script&lang=js"
export * from "./outlinetable.vue?vue&type=script&lang=js"
import style0 from "./outlinetable.vue?vue&type=style&index=0&id=64273efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64273efa",
  null
  
)

export default component.exports